import { render, staticRenderFns } from "./SearchSimple.vue?vue&type=template&id=1588ed5e&scoped=true&"
import script from "./SearchSimple.vue?vue&type=script&lang=js&"
export * from "./SearchSimple.vue?vue&type=script&lang=js&"
import style0 from "./SearchSimple.vue?vue&type=style&index=0&id=1588ed5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1588ed5e",
  null
  
)

export default component.exports